import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ValidationErrors, Validators, } from '@angular/forms';
import { ConfigService, ValidationCheck } from '@infomaniak/angular-common';

import { InvitationPublicCloudCreatePasswodService, } from './invitation-public-cloud-create-password.service';
import { getPasswordValidationMessage } from '@app/shared/password-validation';

type TPublicCloudCreatePasswordSteps = 'initial' | 'create-password' | 'finished' | 'outdated';

@Component({
  selector: 'app-invitation-public-cloud-create-password',
  templateUrl: './invitation-public-cloud-create-password.component.html',
  styleUrls: ['./invitation-public-cloud-create-password.component.scss']
})
export class InvitationPublicCLoudCreatePasswordComponent implements OnInit {

  step: TPublicCloudCreatePasswordSteps = !window['INVITATION'] ? 'outdated' : 'initial';
  form: FormGroup;
  passwordValidation = new ValidationCheck(); // WARNING: change  && typeof this.passwordValidation.dontInclude === 'string' if u pass 'TRUE'

  constructor(
    private invitationPublicCloudCreatePasswodService: InvitationPublicCloudCreatePasswodService,
    private configService: ConfigService,
  ) {
  }

  get displayFormError(): boolean {
    const passwordCtrl = this.form.get('password');

    return passwordCtrl.invalid &&
      passwordCtrl.touched &&
      passwordCtrl.dirty &&
      !passwordCtrl.hasError('required') &&
      !passwordCtrl.hasError('maxlength');
  }

  ngOnInit() {
    this.form = new FormGroup({
      password: new FormControl(null, [
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(72),
        this.passwordValidator.bind(this),
      ]),
    });
  }

  getValidationErrorMessage() {
    return getPasswordValidationMessage(this.passwordValidation);
  }

  generate($event) {
    this.form.get('password').patchValue($event);
    this.form.updateValueAndValidity();
  }

  submitPassword(): void {
    if (this.form.invalid) {
      return;
    }

    this.invitationPublicCloudCreatePasswodService.generatePassword(this.form.get('password').value)
        .then(() => {
          this.step = 'finished';
        })
        .catch(err => {
          this.configService.displayErrors(err);
        });
  }

  // Validators
  private passwordValidator(ctrl: FormControl): ValidationErrors | null {
    return this.passwordValidation.validatePassword(ctrl.value) ? null : { invalid: true };
  }
}
